import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { OtpResponse } from '@components/ui/OtpInput/OtpInput'
import { customerCreate } from '@features/account/api/customer-create'
import { customerResetPasswordToken } from '@features/account/api/customer-reset-password-token'
import clsx from 'clsx'
import React, { MouseEvent, PropsWithChildren } from 'react'
import s from './M55SignupForm.module.scss'

interface Props {
  email: string
  groupId?: string
  text?: string
  type: 'SignUp' | 'ResetPassword'
  isSignedIn?: boolean
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type ConfirmPageProps = Props & NativeAttrs

const ConfirmPage = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<ConfirmPageProps>
>(({ className, email, text, type, isSignedIn, groupId, ...props }, ref) => {
  const handleActionOtp = async (
    e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
  ) => {
    const response = await actionOtpSendToken(email, type, groupId)

    if (response && response.success) {
      var currentTarget = e.target as HTMLAnchorElement

      currentTarget.classList.add(s.disabled)
      currentTarget.innerText = 'Retry in 30 seconds'

      let countdown = 30

      const timer = setInterval(() => {
        countdown--
        currentTarget.innerText = `Retry in ${countdown} seconds`

        if (countdown <= 0) {
          clearInterval(timer)
          currentTarget.innerText = 'Resend code'
          currentTarget.classList.remove(s.disabled)
        }
      }, 1000)

      return () => {
        clearInterval(timer)
      }
    }
  }

  return (
    <div
      className={clsx(s.root, className, { [s.isSignedIn]: isSignedIn })}
      ref={ref}
      {...props}
    >
      <div className={s.textContent}>
        <TrustedHtml html={text} />

        <a onClick={handleActionOtp} className={s.actionOtp}>
          Resend code
        </a>
      </div>
    </div>
  )
})

export const actionOtpSendToken: (
  email: string,
  type: 'SignUp' | 'ResetPassword',
  groupId?: string,
) => Promise<OtpResponse> = async (
  email: string,
  type: 'SignUp' | 'ResetPassword',
  groupId?: string,
) => {
  const url =
    type === 'SignUp'
      ? '/api/account/send-code'
      : '/api/account/send-reset-token'

  if (type === 'SignUp') {
    await customerCreate({ data: { email: email ?? '' } })
  } else {
    await customerResetPasswordToken({ email: email ?? '' })
  }

  return {
    success: true,
    data: {},
  }
}

ConfirmPage.displayName = 'ConfirmPage'
export default ConfirmPage
